import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { getApplicationApi } from "./userApi";

const initialState = {
	prefilled: false,
	consent: { privacy: false, age: false, vulnerability: false },
	application: {
		applicantId: "",
		personalInformation: {
			id: "",
			firstName: "",
			middleName: "",
			lastName: "",
			emailResults: false,
			birthCity: "",
			birthCountryCode: "",
			lastNameAtBirth: "",
			maidenName: "",
			phoneNumber: "",
			birthDate: "",
			gender: "",
			purpose: "",
			organization: "",
		},
		addressInformation: [],
		previousOffences: null,
		authorization: false,
		selfie: "",
		id1: { front: "", back: "" },
		id2: { front: "", back: "" },
	},
	status: "idle",
};
export const getApplicationAsync = createAsyncThunk("user/getApplicationAsync", async () => {
	const response = await getApplicationApi();
	// The value we return becomes the `fulfilled` action payload
	return response;
});
export const userSlice = createSlice({
	name: "user",
	initialState,
	reducers: {
		increment: (state) => {
			state.value += 1;
		},
		decrement: (state) => {
			state.value -= 1;
		},
		incrementByAmount: (state, action) => {
			state.value += action.payload;
		},
		updateConsent: (state, action) => {
			state.consent = { ...state.consent, ...action.payload };
		},
		updatePersonalInformation: (state, action) => {
			state.application.personalInformation = { ...state.application.personalInformation, ...action.payload };
		},
		updateAddressInformation: (state, action) => {
			//sort the addresses from action.payload so the addresses with addressType 0 are first
			const addresses = action.payload.sort((a, b) => {
				if (a.addressType == 0) return -1;
				if (b.addressType == 0) return 1;
			});
			console.log("addresses", addresses);
			state.application.addressInformation = addresses;
		},
		addAddress: (state, action) => {
			state.application.addressInformation = [...state.application.addressInformation, action.payload];
		},
		removeAddress: (state, action) => {
			state.application.addressInformation.splice(action.payload, 1);
		},
		updatePreviousOffences: (state, action) => {
			state.application.previousOffences = action.payload;
		},
		updateAuthorization: (state, action) => {
			state.application.authorization = action.payload;
		},
		updateSelfie: (state, action) => {
			state.application.selfie = action.payload;
		},
		updateId1: (state, action) => {
			state.application.id1 = { ...state.application.id1, ...action.payload };
		},
		updateId2: (state, action) => {
			state.application.id2 = { ...state.application.id2, ...action.payload };
		},
		resetUser: () => initialState,
	},
	extraReducers: (builder) => {
		builder
			.addCase(getApplicationAsync.pending, (state) => {
				console.log("getApplicationAsync pending");
			})
			.addCase(getApplicationAsync.fulfilled, (state, action) => {
				console.log("getApplicationAsync fulfilled with: ", action.payload);

				const application = action.payload.applicant;
				if (application.personalInformation.id) {
					state.prefilled = true;
					state.consent = { age: true, privacy: true, vulnerability: true };
				}
				Object.entries(initialState.application.personalInformation).forEach((entry) => {
					const [key, value] = entry;
					console.log(key);
					console.log(application.personalInformation[key]);
					state.application.personalInformation[key] = application.personalInformation[key];
				});
				state.application.personalInformation.emailResults = true;
				state.application.previousOffences = false;
				const addresses = application.addressInformation.sort((a, b) => {
					if (a.addressType == 0) return -1;
					if (b.addressType == 0) return 1;
				});
				console.log("addresses", addresses);
				state.application.addressInformation = addresses;
				state.application.authorization = application.authorization;
				state.application.selfie = application.selfie ?? "";
				state.application.id1 = application.id1 ?? { front: "", back: "" };
				state.application.id2 = application.id2 ?? { front: "", back: "" };
			})
			.addCase(getApplicationAsync.rejected, (state, action) => {
				console.log("getApplicationAsync rejected");
			});
	},
});

export const {
	increment,
	decrement,
	incrementByAmount,
	updateConsent,
	updatePersonalInformation,
	updateAddressInformation,
	addAddress,
	removeAddress,
	updatePreviousOffences,
	updateAuthorization,
	updateSelfie,
	updateId1,
	updateId2,
	resetUser,
} = userSlice.actions;

export default userSlice.reducer;
